module.exports = __webpack_public_path__ + "img/custom-logo.880ff2fc.png";